import api from '../../api';

export const agents = (params) => api.get('agents', { params });

export const agentsStatus = (params) => api.get('agents/status', { params });

export const user = (id, params) => api.get(`customers/${id}`, { params });

export const viewAgent = (id, params?: any) => api.get('agents/' + id, { params });

export const updateAgent = (id, data) => api.put('agents/' + id, data);

export const updateMeta = (data) => api.put('agents/meta', data);

export const createAgent = (params) => api.post('agents', params);

export const deleteAgent = (id, data) => api.delete('agents/' + id, { data });

export const agentLogs = () => api.get('agents/agent_logs');

export const previousDayagentLogs = () => api.get('agents/previous_agent_logs');

export const getUserCounts = () => api.get('users/counts');

export const generate2faQrcode = (params) => api.get('auth/generate-2fa-qrcode', { params });

export const verify2FAToken = (params) => api.post('auth/verify-2fa-token', params);

export const verify2FAOtp = (params, config) => api.post('auth/verify-2fa-otp', params, config);

export const reset2fa = (params, config) => api.post('auth/reset-2fa', params, config);

export const refreshSession = (refreshToken: string) => api.post('auth/refresh', { refreshToken });
